<template>
  <div class="c-flex-c1" style="">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container fluid pa-0 pb-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <v-layout align-center>
            <div class="display-1 mt-4">
              Quotes
            </div>
          </v-layout>

          <v-layout class="font-weight-medium">
            <v-flex v-ripple pa-2 pl-0 shrink @click="activeTab = 0"
            :class="['c-tab', {'active': activeTab === 0}]">
              In process
            </v-flex>
            <v-flex v-ripple pa-2 shrink @click="activeTab = 1" 
            :class="['c-tab', {'active': activeTab === 1}]">
              Complete
            </v-flex>
          </v-layout>
        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Quotes
            </v-flex>
          </v-layout>
          <v-layout class=" caption text-sans font-weight-medium text-xs-center">
            <v-flex v-ripple pa-2 pl-0 @click="activeTab = 0"
            :class="['c-tab', {'active': activeTab === 0}]">
              In process
            </v-flex>
            <v-flex v-ripple pa-2 @click="activeTab = 1" 
            :class="['c-tab', {'active': activeTab === 1}]">
              Complete
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container fluid class="pa-0">
        <quotes-in-process v-if="activeTab === 0"></quotes-in-process>
        <quotes-complete v-if="activeTab === 1"></quotes-complete>
      </v-container>
    </div>

  </div>
</template>

<script>
import QuotesComplete from './QuotesComplete'
import QuotesInProcess from './QuotesInProcess'

export default {
  name: 'productions',
  components: {
    QuotesComplete,
    QuotesInProcess
  },
  data () {
    return {
      activeTab: 0
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.c-tab {
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;

  &.active {
    border-bottom: 2px solid var(--v-color1-base);
    color: var(--v-color1-base);
  }
}
</style>

